<template>
  <div>
    <a-tabs
      type="card"
      v-decorator="['tags', {
      }]"
      @change="handleChange"
    >
      <a-tab-pane key="basic" tab="套餐详情">
        <basic-info
          :id="id"
          ref="child"
        />
      </a-tab-pane>
      <a-tab-pane key="extraContent" tab="套餐以外收费项目">
        <extra-content
          :id="id"
          ref="child"
        />
      </a-tab-pane>
      <a-tab-pane v-if="!isOutfieldServicePlace" key="buddhistNotes" tab="佛事注意事项">
        <buddhist-notes
          :id="id"
          ref="child"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import BasicInfo from '@/views/orders/tenant/family_notification/BasicInfo'
import ExtraContent from '@/views/orders/tenant/family_notification/ExtraContent'
import BuddhistNotes from '@/views/orders/tenant/family_notification/BuddhistNotes'

export default {
  name: 'ShowDeathInfo',
  components: {
    BasicInfo,
    ExtraContent,
    BuddhistNotes
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isOutfieldServicePlace() {
      return this.$store.getters.tenantServicePlace === 'outfield'
    }
  },
  methods: {
    handleChange(e) {
      return {
        tab: e.tab,
        index: e.index
      }
    },
    fetchData() {
      this.$refs.child.fetchData()
    }
  }
}
</script>

<style lang="less" scoped>
.custom-blue {
  cursor: pointer;
}
</style>
